module.exports = __webpack_public_path__ + "static/media/Pen-White.9c336004.svg";